import { apiSlice } from '../../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['Reservations'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getReservationList: builder.query({
        query: (lakeId) => ({
          url: `fishery/fishery-reservations`,
          params: { lake_id: lakeId },
        }),
        providesTags: (result, error) =>
          error ? [] : [{ type: 'Reservations' }],
      }),
      getReservationBookingDetails: builder.query({
        query: (id) => ({
          url: `fishery/package/booking/details`,
          params: { id: id },
        }),
      }),
      postReservation: builder.mutation({
        query: (data) => ({
          method: 'post',
          url: `fishery/fishery-reservations`,
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'Reservations' }],
      }),
      updateReservation: builder.mutation({
        query: (data) => ({
          method: 'put',
          url: `fishery/fishery-reservations`,
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'Reservations' }],
      }),
      updateReservationCost: builder.mutation({
        query: (data) => ({
          method: 'post',
          url: `fishery/package/booking/cost`,
          data,
          useDefaultErrorHandler: false,
        }),
      }),

      deleteReservation: builder.mutation({
        query: (id) => ({
          url: `fishery/fishery-reservations/delete`,
          method: 'delete',
          params: { package_id: id },
        }),

        invalidatesTags: (result, error) => [{ type: 'Reservations' }],
      }),
    }),
  });

export const {
  useGetReservationListQuery,
  usePostReservationMutation,
  useUpdateReservationMutation,
  useDeleteReservationMutation,
  useUpdateReservationCostMutation,
  useGetReservationBookingDetailsQuery,
} = extendedApiSlice;
